





















import { Component, Prop, Vue,Emit} from 'vue-property-decorator';

@Component

export default class Messsage extends Vue {
    //isActive = false
    @Prop({type: String, default: ''}) private title?: string
    @Prop({type: String, default: ''}) private message?: string
    @Prop({type: String, default: 'OK'}) private confirmText?: string
    @Prop({type: Boolean, default: true}) private isShow?: boolean
  
  created(){
      console.log(this.$props.isShow)
  }

  public onConfirm(yesOrNo: boolean): void{
    //this.isActive = false
    this.$emit("onClose", yesOrNo);
  }

}
